import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import Img from "gatsby-image";

import "./AboutUsHeroBanner.css";

const AboutUsHeroBanner = () => {
    const data = useStaticQuery(graphql`
        query AboutUsHeroBannerQuery {
            mobileImage: file(relativePath: { eq: "about-us-hero-mob.png" }) {
                childImageSharp {
                    fluid {
                        aspectRatio
                        base64
                        srcSet
                    }
                }
            }

            desktopImage: file(relativePath: { eq: "about-us-hero-web.png" }) {
                childImageSharp {
                    fluid {
                        aspectRatio
                        base64
                        srcSet
                    }
                }
            }
        }
    `);

    const sources = [
        data.desktopImage.childImageSharp.fluid,
        {
            ...data.mobileImage.childImageSharp.fluid,
            media: `(max-width: 600px)`,
        },
    ];
    return (
        <div className="aboutus-hb">
            <div className="aboutus-hb__container">
                <Img
                    fluid={sources}
                    alt="PhonePe’s Vision"
                    imgStyle={{
                        height: "100%",
                        width: "100%",
                        objectFit: "cover",
                    }}
                />

                <div className="aboutus-hb__container__header">
                    <div className="aboutus-hb-container">
                        <p>OUR VISION</p>
                        <h2>
                            To build a large, scalable &amp; open <br />
                            transaction ecosystem that <br />
                            creates the maximum positive <br />
                            impact for <em>all</em> stakeholders
                        </h2>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutUsHeroBanner;
